module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/start-down@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/start-down@1x.png
// module id = 731
// module chunks = 0